import { ProfileProgressTrackerModalContent } from "@/components/shared/profile-progress-tracker-header/profile-progress-tracker-modal";
import type { ProfileCompletionState } from "@/lib/profile-completion";

export function QuizProfileGateCard({
  state,
}: {
  state: ProfileCompletionState;
}) {
  return (
    <div className="flex items-center justify-center p-4 py-8">
      <div className="w-full max-w-xl rounded-xl border bg-card shadow-sm overflow-hidden">
        <ProfileProgressTrackerModalContent state={state} />
      </div>
    </div>
  );
}
